module.exports = {
      id: "video-usage",
      viewBox: "0 0 84 64",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#video",
      toString: function () {
        return this.url;
      }
    }